import { FiatWithdrawRequestContext, type IFiatWithdrawRequestContext } from 'BreetComponents';
import { useContext } from 'react';

export const useFiatWithdrawRequestContext = (): IFiatWithdrawRequestContext => {
	const fiatWithdrawRequestContext = useContext(FiatWithdrawRequestContext);

	if (!fiatWithdrawRequestContext) {
		throw new Error('useFiatWithdrawRequestContext must be used within a FiatWithdrawRequestProvider');
	}

	return fiatWithdrawRequestContext;
};
